module.exports = "/build/web/svg/social/default/facebook.62faca2a745ed31d4806cec4542e7e53.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/default/facebook.svg
// module id = 182
// module chunks = 24